//import * as XLSX from "xlsx";
import { format } from "date-fns";

export interface ExportColumn { header: string; key?: string; field?: string; width?: number; }
export interface ExportOptions {
  filename?: string;
  title?: string;
  filters?: Record<string, any>;
  summary?: { 
    total: number; 
    aprobadas: number; 
    pendientes: number; 
    tasaConversion?: string | number;
    total_comisiones?: number;
    chargeback?: number;
    equifax?: number;
    total_pagar?: number;
  };
  headerImageUrl?: string;
}

/* ================= EXCEL ================= */

export const exportToExcel = (data: any[], columns: ExportColumn[], options: ExportOptions = {}) => {
  try {
    const { filename = `Reporte_Comisiones_${format(new Date(),"yyyy-MM-dd_HH-mm")}.xlsx`,
            title = "Reporte Comisiones Vendedores externos", summary } = options;

    const wb = XLSX.utils.book_new();
    const excelData: any[] = [];
    excelData.push([title], []);
    excelData.push(["Fecha de generación:", format(new Date(),"dd/MM/yyyy HH:mm:ss")]);
    excelData.push(["Total visibles en tabla:", data.length], []);
    excelData.push(columns.map(c=>c.header));
    for (const row of data) excelData.push(columns.map(c=>formatCellValue(getNestedValue(row, c.field || c.key || ""))));
    
    // Agregar resumen si existe
    if (summary) {
      excelData.push([]);
      excelData.push(["RESUMEN EJECUTIVO"]);
      excelData.push(["Total de registros:", summary.total]);
      excelData.push(["Exitosas:", summary.aprobadas]);
      excelData.push(["Pendientes:", summary.pendientes]);
      if (summary.total_comisiones !== undefined) {
        excelData.push(["TOTAL COMISION EN VENTAS:", summary.total_comisiones]);
      }
      if (summary.chargeback !== undefined) {
        excelData.push(["(-)CHARGEBACK:", summary.chargeback]);
      }
      if (summary.equifax !== undefined) {
        excelData.push(["(-)EQUIFAX:", summary.equifax]);
      }
      if (summary.total_pagar !== undefined) {
        excelData.push(["TOTAL A PAGAR:", summary.total_pagar]);
      }
    }

    const ws = XLSX.utils.aoa_to_sheet(excelData);
    ws["!cols"] = columns.map(c=>({ wch: c.width || 18 }));
    XLSX.utils.book_append_sheet(wb, ws, "Reporte");
    XLSX.writeFile(wb, filename);
    return true;
  } catch (e) { console.error("Error al exportar a Excel:", e); return false; }
};

const getNestedValue = (obj:any, path:string): any => {
  if (!path || path === "") return undefined;
  return path.split(".").reduce((acc,p)=> (acc? acc[p] : undefined), obj);
};
const formatCellValue = (v:any): string =>
  v==null ? "-" : typeof v==="boolean" ? (v?"SÍ":"NO") :
  v instanceof Date ? format(v,"dd/MM/yyyy HH:mm") :
  typeof v==="number" ? String(v) : typeof v==="object" ? JSON.stringify(v) : String(v);
